// extracted by mini-css-extract-plugin
export default {"wrapper":"requestDemo_wrapper__E-3PH","inner":"requestDemo_inner__xbM0S"};